import { render } from "./FormMultiSelect.vue?vue&type=template&id=b2c992c4&scoped=true"
import script from "./FormMultiSelect.vue?vue&type=script&lang=js"
export * from "./FormMultiSelect.vue?vue&type=script&lang=js"

import "./FormMultiSelect.vue?vue&type=style&index=0&id=b2c992c4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2c992c4"]])

export default __exports__